// extracted by mini-css-extract-plugin
module.exports = {"description":"list_description_2Sxyp"};